function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("clipPath", {
  id: "clip-Artboard_3"
}, React.createElement("rect", {
  width: 35,
  height: 35
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  id: "Artboard_3",
  "data-name": "Artboard \\u2013 3",
  clipPath: "url(#clip-Artboard_3)"
}, React.createElement("rect", {
  width: 35,
  height: 35,
  fill: "#fff"
}), React.createElement("g", {
  id: "Group_47",
  "data-name": "Group 47",
  transform: "translate(1 0.3)"
}, React.createElement("g", {
  id: "Group_46",
  "data-name": "Group 46",
  transform: "translate(0 4)"
}, React.createElement("path", {
  id: "net_1",
  "data-name": "Path 43",
  d: "M233.7,114.982c-7.464,3.951-10.279,14.054-5.612,21.834",
  transform: "translate(-225.811 -113.5)",
  fill: "none",
  stroke: "#707070",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("path", {
  id: "net_2",
  "data-name": "Path 47",
  d: "M244.5,113.5a14.491,14.491,0,0,1,11.857,13.147",
  transform: "translate(-225.811 -113.5)",
  fill: "none",
  stroke: "#707070",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("path", {
  id: "net_3",
  "data-name": "Path 48",
  d: "M235.5,142.5c7.21,2.4,14.252-.065,19-6",
  transform: "translate(-225.811 -113.5)",
  fill: "none",
  stroke: "#707070",
  strokeMiterlimit: 10,
  strokeWidth: 2
})), React.createElement("g", {
  id: "net_4",
  "data-name": "Ellipse 31",
  transform: "translate(9)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 2
}, React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 4,
  stroke: "none"
}), React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 3,
  fill: "none"
})), React.createElement("g", {
  id: "net_5",
  "data-name": "Ellipse 32",
  transform: "translate(1 27)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 2
}, React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 4,
  stroke: "none"
}), React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 3,
  fill: "none"
})), React.createElement("g", {
  id: "net_6",
  "data-name": "Ellipse 33",
  transform: "translate(26 18)",
  fill: "#fff",
  stroke: "#707070",
  strokeWidth: 2
}, React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 4,
  stroke: "none"
}), React.createElement("circle", {
  cx: 4,
  cy: 4,
  r: 3,
  fill: "none"
}))));

var SvgNetwork = function SvgNetwork(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgNetwork, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/network.b44f1fae.svg";
export { ForwardRef as ReactComponent };